import React, { Fragment } from "react";
import GroupBarchart from "../../../../../d3Components/NewBarchart/GroupBarchart";
import Spinner from "../../../Datatable/spinner/spinner";
import Legend from "../../../../../d3Components/legend";
import SimpleTable from "../../../common/simpleTable";
import WithCard from "../../../../../common/withCard";

const CalenderYearPerformance = (props) => {
  const { data, benchmark_name, typeName, initialWidth } = props;
  return (
    <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
      {props.spinner ? (
        <Spinner />
      ) : (
        <WithCard>
          <h4 className="text-uppercase bold">
            CALENDAR YEAR BACK-TESTED PERFORMANCE
          </h4>
          {data.length > 0 ? (
            <Fragment>
              <div style={{ overflowX: "auto" }}>
                <Legend height={30} width={500} legend2={typeName} />
                <GroupBarchart
                  width={initialWidth}
                  height={300}
                  data={data}
                  targetDiv="backtestBarChart4"
                />
              </div>
              <SimpleTable
                rowHead1={"Portfolio"}
                rowHead2={"Benchmark"}
                heading={data.map((d, i) => {
                  return <td key={i}>{d.metric_name}</td>;
                })}
                Row1={data.map((d, i) => {
                  return <td key={i}>{`${d.portfolio.toFixed(2)} %`}</td>;
                })}
                Row2={data.map((d, i) => {
                  return <td key={i}>{`${d.benchmark.toFixed(2)} %`}</td>;
                })}
              />
              {benchmark_name ? (
                <div>
                  <small>
                    <b>*</b>&nbsp; {benchmark_name}
                  </small>
                </div>
              ) : null}
            </Fragment>
          ) : null}
        </WithCard>
      )}
    </div>
  );
};

export default CalenderYearPerformance;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/backtest/returns/section1/monthlyPerformance.jsx